module.exports = __webpack_public_path__ + "img/wrapbg3.d7f3e7f6.png";